module.exports = __webpack_public_path__ + "static/media/02.f6865b0e.png";